import React, { useRef, useState } from "react";
import stylesPc from "./CustomMediaRecorder.module.css";
import stylesSp from "./CustomMediaRecorder_SP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
import { Button, Modal } from "@material-ui/core";
import OnLeaveDialog from "../../../../common/components/dialog/OnLeaveDialog";
import { useDispatch } from "react-redux";
import {
    DeleteMediaRecorderVideoFile,
    SetMediaRecorderVideoFile,
} from "../../../../common/video/VideoActions";
import ClearIcon from "@material-ui/icons/Clear";
import { t } from "i18next";

interface CustomMediaRecorderProps {
    openAdminModal?: (contentType: string) => void;
    setMediaRecorderVideoFile?: (file: any) => void;
    // setMediaRecorderVideoFile: (file: File) => void;
}

export default function CustomMediaRecorder({
    openAdminModal,
    setMediaRecorderVideoFile,
}: CustomMediaRecorderProps) {
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;
    const dispatch = useDispatch();
    const videoElem = document.getElementById("video");

    const videoRef = useRef<HTMLVideoElement>(null);
    const [mediaBlobUrl, setMediaBlobUrl] = useState("");
    const [isOpenOnLeaveDialog, setIsOpenOnLeaveDialog] = useState(false);
    const [isOpenRecorderModal, setIsOpenRecorderModal] = useState<boolean>(false);

    // 動画ファイルのダウンロード
    const handleDownloadVideo = () => {
        if (!mediaBlobUrl || mediaBlobUrl === "") return;
        const a = document.createElement("a");
        const dd = new Date();
        a.style.display = "none";
        a.href = mediaBlobUrl;
        a.download = `画面収録 ${dd.toLocaleDateString().replace(/\//g, "-")} ${dd
            .toLocaleTimeString()
            .replace(/:/g, ".")}.webm`;
        document.body.appendChild(a);
        a.click();
    };

    const handleOpenAdminModal = (contentType: string) => {
        if (!openAdminModal) return;
        openAdminModal(contentType);
        setIsOpenRecorderModal(false);
    };

    const handleCloseRecorderModal = () => {
        setIsOpenOnLeaveDialog(true);
    };

    const handleCloseDialog = () => {
        setIsOpenOnLeaveDialog(false);
        setIsOpenRecorderModal(false);
        setMediaBlobUrl("");
        dispatch(DeleteMediaRecorderVideoFile());
    };

    const handleCancel = () => {
        setIsOpenOnLeaveDialog(false);
    };

    const handleConfirm = () => {
        handleCloseDialog();
    };

    const startCapture = async () => {
        // const mimeType = "video/webm";
        // const isSupportMediaRecorder = MediaRecorder.isTypeSupported(mimeType) ? true : false;
        try {
            const mediaDevices = navigator.mediaDevices as any;
            const chunks: BlobPart[] | undefined = [];
            // 動画スクリーンキャプチャ
            const videoStream = await mediaDevices.getDisplayMedia({
                video: true,
                audio: false,
            });

            // 音声（videoをtrueにするとカメラの撮影もできる）
            const audioStream = await mediaDevices.getUserMedia({
                video: false,
                audio: true,
            });

            // 動画スクリーンキャプチャ、音声を統合させる
            const combinedStream = new MediaStream([
                ...videoStream.getTracks(),
                ...audioStream.getTracks(),
            ]);
            const mediaRecorder = new MediaRecorder(combinedStream, {
                mimeType: "video/webm; codecs=vp9",
                bitsPerSecond: 500000,
            });

            if (videoElem) {
                (videoElem as HTMLVideoElement).srcObject = audioStream;
            }

            mediaRecorder.ondataavailable = (event) => {
                if (event.data && event.data.size > 0) {
                    chunks.push(event.data);
                }
            };
            mediaRecorder.start(20000);

            mediaRecorder.onstop = async () => {
                const webm = new Blob(chunks, { type: "video/webm" });
                const url = window.URL.createObjectURL(webm);
                const dd = new Date();

                const videoFile = new File(
                    chunks,
                    // [url],
                    `画面収録 ${dd.toLocaleDateString().replace(/\//g, "-")} ${dd
                        .toLocaleTimeString()
                        .replace(/:/g, ".")}.mp4`,
                    { type: "video/mp4" }
                );
                setMediaBlobUrl(url);
                dispatch(SetMediaRecorderVideoFile(videoFile));
                if (setMediaRecorderVideoFile) setMediaRecorderVideoFile(videoFile);

                setIsOpenRecorderModal(true);
            };

            // 動画スクリーンキャプチャが終了する際に、音声も終了させる
            videoStream.getTracks()[0].addEventListener("ended", () => {
                audioStream.getVideoTracks().forEach((track: any) => {
                    track.stop();
                });
                audioStream.getAudioTracks().forEach((track: any) => {
                    track.stop();
                });
            });
        } catch (err) {
            console.error(`Error: ${err}`);
        }
    };

    // const stopCapture = () => {
    //     if (videoElem) {
    //         const tracks = ((videoElem as HTMLVideoElement).srcObject as any).getTracks();
    //         tracks.forEach((track: { stop: () => any }) => track.stop());
    //         (videoElem as HTMLVideoElement).srcObject = null;
    //     }
    // };

    return (
        <>
            <div id="startCaptureButton" className={styles.btn} onClick={startCapture}></div>
            {/* <div onClick={stopCapture}>Stop Recording</div> */}
            {/* <video id="video" src={mediaBlobUrl} controls autoPlay className={styles.video} /> */}

            <Modal
                open={isOpenRecorderModal}
                onClose={handleCloseRecorderModal}
                className={styles.recorderModal}
            >
                <div className={styles.modal}>
                    <h2 className={styles.modalTitle}>{t("録画が完了しました。")}</h2>
                    {mediaBlobUrl && (
                        <div className={styles.videoArea}>
                            <div className={styles.videoTitle}>{t("レビュー")}</div>
                            <div className={styles.videoDiv}>
                                <video
                                    ref={videoRef}
                                    src={mediaBlobUrl}
                                    controls
                                    autoPlay
                                    controlsList="nodownload"
                                    disablePictureInPicture
                                    className={styles.video}
                                />
                                <div className={styles.hoverContent}>
                                    <div className={styles.videoHoverBg}></div>
                                    <div className={styles.reshootButton}>
                                        <Button
                                            variant="outlined"
                                            className={`${styles.btnStyle} ${styles.uploadButton}`}
                                            onClick={startCapture}
                                        >
                                            {t("録画をやり直す")}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className={styles.buttonGroup}>
                        <Button
                            variant="outlined"
                            onClick={handleDownloadVideo}
                            className={styles.btnStyle}
                        >
                            {t("ダウンロード")}
                        </Button>
                        {/* <Button
                            variant="outlined"
                            className={styles.btnStyle}
                            // onClick={() => handleOpenAdminModal("video")}
                        >
                            cineonstudio にアップロード
                        </Button> */}
                        <Button
                            variant="outlined"
                            className={`${styles.btnStyle} ${styles.uploadButton}`}
                            onClick={() => handleOpenAdminModal("video")}
                        >
                            {t("cineonhub にアップロード ")}
                        </Button>
                    </div>

                    <div className={styles.closeButton} onClick={handleCloseRecorderModal}>
                        <ClearIcon
                            style={{
                                cursor: "pointer",
                                color: "#808080",
                                top: "15px",
                                right: "15px",
                                position: "fixed",
                            }}
                        />
                    </div>
                </div>
            </Modal>

            <OnLeaveDialog
                openDialog={isOpenOnLeaveDialog}
                dialogTitle={t("このページを移動しますか？")}
                dialogContent={t("ページを移動すると、録画した内容が失われます")}
                dialogActions={t("閉じる")}
                handleCloseDialog={handleCloseDialog}
                handleCancel={handleCancel}
                handleConfirm={handleConfirm}
            />
        </>
    );
}
